import { ESectionColor, Section, SectionTitle } from '@web_opxp/components';
import * as React from 'react';
import { SKELETON_CLASSNAME } from '../../base/constants';
import SelectionItem from './SelectionItem';
import { ISelectionItem } from './types';

export interface ISelectionSectionProps {
  selections: ISelectionItem[];
  onSelect: (id: number) => void;
  type: 'large' | 'regular' | 'special_needs';
  title: React.ReactNode;
  loading?: boolean;
}

const SelectionSection: React.FC<ISelectionSectionProps> = ({ onSelect, selections, type, title, loading = false }) => {
  const itemClass = `col-3 ${loading ? SKELETON_CLASSNAME : ''}`;
  return (
    <Section className={`selection-section selection-section__${type}`} color={ESectionColor.blue}>
      <SectionTitle>{title}</SectionTitle>
      <div className="row selection-section-container">
        {selections.map((selection) => (
          <div className={itemClass} key={`${selection.title}${selection.id}`}>
            <SelectionItem onSelect={onSelect} {...selection} type={type} />
          </div>
        ))}
      </div>
    </Section>
  );
};

export default SelectionSection;
